// extracted by mini-css-extract-plugin
export default {"searchInput":"stringFormItem_searchInput__4r3U+"};